import http from './http'

export function fetchRecentPredictions(params) {
  return http.get('/api/prediction/recent', { params })
}

export function fetchPredictionSections(params) {
  return http.get('/api/prediction/sections', { params })
}

export function fetchPredictionItems(params) {
  return http.get('/api/prediction/items', { params })
}
